import { render, staticRenderFns } from "./ClubRenewal.vue?vue&type=template&id=61f0de25"
import script from "./ClubRenewal.vue?vue&type=script&lang=js"
export * from "./ClubRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports